import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    border: "solid 1px #D3D5DB",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#F5F5F5",
  },
  iframe: {
    width: "100%",
    borderRadius: "0.5rem",
    height: "45vh",
  },
  unread: {
    backgroundColor: "#edefff !important",
    "&:hover": {
      backgroundColor: "#e1e4fc !important",
    },
  },
}));
